"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ws = require("websocket");
const Error_1 = require("../shared/Error");
class SocketClient {
    constructor(router, connectionURL) {
        this.router = router;
        this.connectionURL = connectionURL;
        this.connected = false;
    }
    connect() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                if (this.connected)
                    resolve();
                this.client = new ws.w3cwebsocket(`${this.connectionURL}?auth=5985925853`);
                this.client.onopen = () => {
                    this.connected = true;
                    resolve();
                };
                this.client.onmessage = message => {
                    this.router.handleMessage(message);
                };
                this.client.onclose = event => {
                    this.connected = false;
                    console.log(event);
                };
                this.client.onerror = event => {
                    this.connected = false;
                    console.log(event);
                    reject(Error_1.CustomerAuthnError.CONNECTION_ERROR);
                };
            });
        });
    }
    send(payload) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.connected)
                yield this.connect();
            try {
                (_a = this.client) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify(payload));
                return Promise.resolve();
            }
            catch (_e) {
                return Promise.reject(Error_1.CustomerAuthnError.CONNECTION_ERROR);
            }
        });
    }
}
exports.default = SocketClient;
//# sourceMappingURL=SocketClient.js.map